<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                flat
                dark
              >
                <v-toolbar-title>Password Reset Form</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model="email"
                    label="E-mail"
                    name="email"
                    prepend-icon="mdi-account"
                    type="text"
                  ></v-text-field>

                  <v-text-field
                    v-model="token"
                    label="Token (optional)"
                    name="token"
                    prepend-icon="mdi-check"
                    type="token"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="resetRequest()" color="secondary">Request Token</v-btn>
                <v-btn @click="reset()" color="secondary">Reset Password</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import { RESET_PASSWORD_REQUEST_MUTATION, RESET_PASSWORD_MUTATION } from '../../graphql/authenticationQueries.js';

  export default {
    props: {
      source: String,
    },
    data () {
      return {
        email: null,
        token: null,
      }
    },
    apollo: {
      $client: 'authenticationClient'
    },
    methods: {
      async resetRequest(){
        const { email } = this.$data;
        try {
          const result = await this.$apollo.mutate({
            mutation: RESET_PASSWORD_REQUEST_MUTATION,
            variables: {
              email: email
            }
          });
          
          if (result.data.resetPasswordRequest === true) {
            alert("Check your email inbox for one time token");
          }
          else {
            alert('Password reset request failed (1)');
          }
        } catch (error) {
          alert('Password reset request failed (2)');
        }
      },

      async reset(){
        const { email, token } = this.$data;
        try {
          const result = await this.$apollo.mutate({
          mutation: RESET_PASSWORD_MUTATION,
          variables: {
            email: email,
            token: token
          }
        });
        
        if (result.data.resetPassword === true) {
            alert(`Password successfully reset for user '${email}'! Check your email for your new temporary password.`);
            this.$router.push({path: '/login'})
        }
        } catch (error) {
          alert(`Error trying to rest password for user '${email}'!`);
        }
      }
    }
  }
</script>